import React from "react";
import PropTypes from "prop-types";
import Radium from "radium";
import { baseStyles } from "../../utils/baseStyles";
import PercentChanged from "../percentChanged/percentChanged";
import ReactTooltip from "react-tooltip";
import { asNumberString } from "../../utils/formatters";
import UserAvatar from "../../components/userAvatar/userAvatar";

function ProfileStatsBlock(props) {
  /**
   * TODO: Props currently mock data. Needs to be replaced
   * with defaults.
   *
   * TODO: Colors need to be programmatically generated
   */
  props = {
    bigPercentToolTip: "Class Utilization",
    ...props
  };

  if (props.data.length > 0) {
    const data = {
      firstName: props.data[props.index].firstName,
      lastName: props.data[props.index].lastName,
      attendancePercentage: props.data[props.index].percentage,
      totalAttendees: props.data[props.index].totalAttendees,
      totalPotentialAttendees: props.data[props.index].totalPotentialAttendees,
      percentChange: props.data[props.index].percentChange,
      newAttendees: props.data[props.index].newAttendees,
      topClasses: props.data[props.index].topClasses,
      userImg: props.data[props.index].imageUrl
    };

    const truncateName = (firstName, lastName) => {
      return `${firstName} ${lastName.charAt(0) + "."}`;
    };

    return (
      <div
        className={!props.topPerformer ? "profile-stats-container" : "profile-stats-container-background"}
        style={[styles.container, !props.topPerformer && styles.backgroundNone]}
      >
        <h2 style={styles.name}>{truncateName(data.firstName, data.lastName)}</h2>
        <div style={styles.gridContainer}>
          {data.userImg !== "" ? <img style={styles.profileImage} src={data.userImg} /> : <UserAvatar firstName={data.firstName} lastName={data.lastName} />}
          <div style={styles.attendance}>
            <h5 style={styles.title}>Attendance</h5>
            <p data-tip={props.bigPercentToolTip} style={styles.attendance.percentage}>
              {Math.round(data.attendancePercentage * 100)}%
            </p>
            <div>
              <p style={styles.attendance.number}>
                {asNumberString(data.totalAttendees)} of {asNumberString(data.totalPotentialAttendees)}
              </p>
            </div>
            <div style={styles.attendance.percent}>
              <PercentChanged changeValue={data.percentChange} showBorder toolTip="Attendance change from previous month" />
            </div>
          </div>
        </div>
        {props.topPerformer && (
          <div style={styles.secondRow}>
            <div style={styles.newAttendees}>
              <h5 style={styles.title}>New Attendees</h5>
              <p style={styles.newAttendees.number}>{data.newAttendees}</p>
            </div>
            <div style={styles.topClasses}>
              <h5 data-tip="Ranked by Headcount" style={styles.title}>
                Top Classes
              </h5>
              <ul style={styles.topClasses.list}>
                {data.topClasses.map((classProps, index) => {
                  return (
                    <li key={classProps.id} style={styles.topClasses.list.li}>
                      {classProps.name}
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        )}
        <ReactTooltip />
      </div>
    );
  } else {
    return null;
  }
}

var styles = {
  gridContainer: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    div: {
      width: "50%"
    }
  },
  secondRow: {
    marginTop: "20px",
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    div: {
      width: "50%"
    }
  },
  name: {
    paddingTop: "0",
    marginTop: "0",
    fontFamily: "Open sans",
    color: "white",
    fontSize: "20px",
    textTransform: "uppercase"
  },
  attendance: {
    width: "60%",
    percentage: {
      fontSize: "50px",
      lineHeight: "1em",
      color: "#4a9bff",
      padding: "0",
      margin: "0"
    },
    percent: {
      position: "relative",
      top: "6px",
      left: "-3px"
    },
    number: {
      fontSize: "16px",
      color: "#92bef4",
      padding: "0",
      margin: "0",
      float: "left"
    },
    percentChange: {
      float: "right"
    }
  },
  container: {
    width: "100%",
    maxWidth: "325px",
    minHeight: "325px",
    backgroundColor: "#1b1d22",
    padding: "20px 9px 20px 20px",
    fontFamily: "Open Sans, Arial",
    h2: {
      margin: "0",
      padding: "0"
    }
  },
  backgroundNone: {
    backgroundColor: "transparent"
  },
  profileImage: {
    maxWidth: "100px",
    borderRadius: "100px",
    height: "100px",
    objectFit: "cover"
  },
  newAttendees: {
    width: "50%",
    number: {
      fontSize: "50px",
      lineHeight: "1em",
      color: "#92bef4",
      margin: "0"
    }
  },
  topClasses: {
    width: "50%",
    list: {
      listStyleType: "none",
      padding: "0",
      margin: "0",
      li: {
        color: "#92bef4",
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis"
      }
    }
  },
  title: {
    padding: "0",
    margin: "0",
    ...baseStyles.sectionTitle
  },
  category: baseStyles.categoryTitle
};

export default Radium(ProfileStatsBlock);

ProfileStatsBlock.propTypes = {
  index: PropTypes.number,
  data: PropTypes.any,
  topPerformer: PropTypes.boolean,
  bigPercentToolTip: PropTypes.string
};
